/*
 *  This file global.constants.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */



import { DBConfig } from 'ngx-indexed-db';
import { TCoreMenuAccessTeamActionsForPin } from 'src/app/main/sidebar/sidebar.model';
import { IFeedResponse, TFeedCountResponse, TReferralDataResponse } from 'src/app/modules/enterprise-wall/social-enterpise-wall/social-wall.model';



export type TWorkforceSetupSettingResponse = {
  multipleUpdate: boolean;
  settingId: number;
  settingName: string;
  status: string;
  isActive: boolean;
  controlType: "radiobutton" | "textbox" | "dropdown";
}

export const ADD_EMPLOYEE_STATUS_SETTING_ID = 124;

export type TCoreFeatureValidate = {
  id: number;
  moduleId: number;
  featureId: number;
  menuIds: string;
  isActive: number;
  numberOfUser: number;
  totalLicenseNumber: number;
  usedLicenseNumber: number;
  message: string;
}

export type TPageAccessRightStoreData = {
  refresh: boolean,
  menuAction: TCoreMenuAccessTeamActionsForPin | null,
  menuList: TCoreMenuAccessResponse[] | null,
  menuAccess: TCoreMenuAccessResponse[] | null,
};
export type TContestEnableDisableResponse = {
  contestId: number;
  result: boolean;
  backgroudImageUrl: string;
  backgroudImageMobileUrl: string;
  htmlTag: string;
  footerTag: string;
  followLink: string;
  knowMoreLink: string;
  htmlData: HTMLData;
}

export type HTMLData = {
  heading: string;
  subheading: string;
  label: string[];
  bulletHeading: string;
  bullet: string[];
  bulletFooter: string;
}

export type TDepartment = {
  departmentCode: string,
  departmentName: string,
  activeStatus: string
}
export type TSubDepartment = {
  departmentCode: string,
  departmentName: string,
  activeStatus: string,
  subDepartmentCode: string,
  subDepartmentName: string
}

export type TBusinessUnits = {
  businessUnitCode: string,
  businessUnitName: string,
  companyCode: string,
  companyName: string,
  activeStatus: string,
  isCommonMapping: boolean
}
export type TLevel = {
  levelCode: string,
  levelName: string,
  activeStatus: string,
}
export type TDesignation = {
  "jobFamilyId": unknown,
  "primarySkillId": unknown,
  "designationCode": string,
  "designationName": string,
  "activeStatus": string,
  "gradeId": unknown,
  "designationMaxSalary": number,
  "designationMinSalary": number,
  "designationMaxExperience": number,
  "designationMinExperience": number,
  "hazardousStatus": boolean,
  "designationSkillDetails": unknown,
  "jobDescriptionBody": unknown,
  "jobDescriptionBodyWithHtml": unknown,
  "skillsName": unknown,
  "removeImageDbNames": unknown
}
export type TGrades = {
  gradeCode: string,
  gradeName: string,
  activeStatus: string
}
export type TRegion = {
  regionCode: string,
  regionName: string,
  activeStatus: string,
  cityCode?: string,
  cityName?: string
}
export type TSubBranches = {
  activeStatus: string,
  address: string,
  allowGeoLocationMapping: string,
  allowPolygonMapping: string,
  branchCode: string,
  branchName: string,
  geoLocation: unknown,
  latitude: unknown,
  longitude: unknown,
  maximumWorkforce: number,
  minimumWorkforce: number,
  pin: string,
  polygonDetails: unknown,
  subBranchCode: string,
  subBranchName: string,
}

export type TTaxRegimeResponse = {
  financialYear: string,
  showTaxRegime: boolean,
  taxRegime: string,
  taxRegimePopupMandatory: boolean,
  considerConfirmInvestment: boolean,
}
export type THelpdeskTicketFeedback = {
  logOnUserCode: string;
  domainCode: string;
  logOnUserId: number;
  logOnUserName: string;
  currentUserLogOnType: string;
  categoryId: number;
  subcategoryId: number;
  priorityId: number;
  requestId: number;
  routCourse: string;
  isRcaRequired: boolean;
  categoryName: string;
  subcategoryName: string;
  priorityName: string;
  ticketCode: string;
  employeeId: number;
  feedbackCloseById: string;
  closedByEmployeeCode: string;
  closedByFirstName: string;
  closedByMiddleName: string;
  closedByLastName: string;
  closedByFullName: string;
  closedByPhoto: string;
}

export type TWorkflowInboxSetting = {
  inboxTypeId: number;
  flowId: number;
  inboxTypeName: string;
  isMoveToArchive: boolean;
  isTaskDelegate: boolean;
  isTaskDelegateExists: boolean;
  isEditWorkflow: boolean;
  isBulkApprovalExists: boolean;
  isBulkApproval: boolean;
  isMoveToArchiveExists: boolean;
  isTaskEditWorkflowExists: boolean;
  isDiscussionEnabledExists: boolean;
  isDiscussionEnabled: boolean;
}


export type  IMoodSettingType = {
 settingId: number;
 enableMoodBot: boolean;
 feedbackFrequency: number;
 weekday: number;
 time: string;
 anonymousFeedback: boolean;
}

export enum EGlobalStateStoreNames {
  Feed = 'feed',
  EmployeeContest = 'employeecontest',
  PageAccessRights = 'pageaccessrights',
  SubscriberModules = 'subscribermodules',
  ValidateFeature = 'validatefeature',
  WorkforceSetupSetting = 'workforcesetupsetting',
  EnterpriseContest = 'enterprisecontest',
  RankDetail = 'rankdetail',
  Enterprise = 'enterprise',
  Departments = 'departments',
  SubDepartment = 'subdepartment',
  BusinessUnit = 'businessunit',
  Level = 'level',
  Designation = 'designation',
  Grade = 'grade',
  SubBranch = 'subbranch',
  Branch = 'Branch',
  Region = 'Region',
  Company = 'company',
  GeneralSettings = 'generalsettings',
  Country = 'country',
  State = 'state',
  City = 'city',
  Referralposting = 'referralposting',
  SocialWallWidget = 'socialwallwidget',
  RecruiterAccessSetting = 'recruiteraccesssetting',
  RecruitmentGeneralSetting = 'recruitmentgeneralsetting',
  OneAIFeature = 'oneaifeature',
  TaxRegime = 'taxregime',
  TimeOfficeExtension = 'timeofficeextension',
  MoodbotDetail = 'moodbotdetail',
  MoodbotReasionList = 'moodbotreasionlist',
  PayrollGeneralSetting = 'payrollgeneralsetting',
  WorkflowInboxSetting = 'workflowinboxsetting',
  HelpdeskTicketFeedback = 'helpdeskticketfeedback',
}
export enum EGlobalStateProcessId {
  PageAccessRights = 1,
  EmployeeContest = 2,
  Feed = 3,
  SubscriberModules = 4,
  WorkforceSetupSetting = 5,
  ValidateFeature = 6,
  EnterpriseContest = 7,
  RankDetail = 8,
  Departments = 16,
  Enterprise = 10,
  SubDepartment = 17,
  BusinessUnit = 12,
  Level = 20,
  Designation = 18,
  Grade = 19,
  SubBranch = 14,
  Branch = 13,
  Region = 15,
  Company = 11,
  GeneralSettings = 9,
  Country = 21,
  State = 22,
  City = 23,
  Referralposting = 24,
  SocialWallWidget = 25,
  RecruiterAccessSetting = 26,
  RecruitmentGeneralSetting = 27,
  OneAIFeature = 34,
  TaxRegime = 35,
  TimeOfficeExtension = 36,
  MoodbotDetail = 37,
  MoodbotReasionList = 38,
  HelpdeskTicketFeedback = 39,
  PayrollGeneralSetting = 44,
  WorkflowInboxSetting = 46
}
export const GLOBAL_API_URLS = {
  [EGlobalStateProcessId.PageAccessRights]: {
    REFRESH_PAGE_ACCESS_RIGHT: '/api/LogOnUser/refresh/LogOnUser/PageAccessRight/W',
    MENU_ACCESS: '/api/core/MenuAccess',
  },
  [EGlobalStateProcessId.EnterpriseContest]: {
    CONTEST_ENABLE_DISABLE: '/api/Contest/ContestEnableDisable/true',
  },
  [EGlobalStateProcessId.Feed]: {
    BADGE_FEED: '/api/Engage/Badge/Feed',
    FEED_COUNT: `/api/SocialWall/v2/FeedCount`
  },
  [EGlobalStateProcessId.SubscriberModules]: {
    SUBSCRIBE_MODULE: '/api/SubscribeModule/Module',
  },
  [EGlobalStateProcessId.WorkforceSetupSetting]: {
    WORKFORCE_SETUP_SETTING: '/api/workforce/setup/Setting/',
    WORKFORCE_SETUP_SETTING_ALL: '/api/workforce/setup/Setting/All',
  },
  [EGlobalStateProcessId.ValidateFeature]: {
    VALIDATE_FEATURE: '/api/core/feature/Validate'
  },
  [EGlobalStateProcessId.EmployeeContest]: {
    EMPLOYEECONTESTENABLEDISABLESTATUS: `/api/Contest/EmployeeContestEnableDisableStatus`,
  },
  [EGlobalStateProcessId.RankDetail]: {
    RANK_DETAIL: '/api/Engage/WallOfFame/RankDetail'
  },
  [EGlobalStateProcessId.Enterprise]: {
    ENTERPRISE: '/api/core/Enterprise',
    LEGO_ORG_ID: '/api/core/global/Enterprise/Access/OrgId'
  },
  [EGlobalStateProcessId.Departments]: {
    DEPARTMENTS: '/api/core/Department'
  },
  [EGlobalStateProcessId.SubDepartment]: {
    SUB_DEPARTMENT: '/api/core/subdepartment',
  },
  [EGlobalStateProcessId.BusinessUnit]: {
    BUSINESS_UNIT: '/api/core/BusinessUnit',
  },
  [EGlobalStateProcessId.Level]: {
    LEVEL: '/api/core/Level',
  },
  [EGlobalStateProcessId.Designation]: {
    DESIGNATION: '/api/core/Designation',
  },
  [EGlobalStateProcessId.Grade]: {
    GRADE: '/api/core/Grade',
  },
  [EGlobalStateProcessId.SubBranch]: {
    SUB_BRANCH: '/api/core/SubBranch',
  },
  [EGlobalStateProcessId.Branch]: {
    BRANCH: '/api/core/Branch'
  },
  [EGlobalStateProcessId.Region]: {
    REGION: '/api/core/Region'
  },
  [EGlobalStateProcessId.Company]: {
    COMPANY: '/api/core/Company'
  },
  [EGlobalStateProcessId.GeneralSettings]: {
    GENERAL_SETTINGS: '/api/Engage/Setting/GeneralSetting'
  },
  [EGlobalStateProcessId.Country]: {
    COUNTRY: '/api/core/Country'
  },
  [EGlobalStateProcessId.State]: {
    STATE: '/api/core/State'
  },
  [EGlobalStateProcessId.City]: {
    CITY: '/api/core/City'
  },
  [EGlobalStateProcessId.Referralposting]: {
    GET_TOTAL_JOB_OPENING: '/api/recruitment/referralposting/v1',
  },
  [EGlobalStateProcessId.SocialWallWidget]: {
    GET_WIDGET_SEQUENCE: '/api/SocialWall/v2/Widget',
  },
  [EGlobalStateProcessId.RecruiterAccessSetting]: {
    GET_RECRUITER_ACCESS_SETTING: '/api/recruitment/setting/RecruiterAccessSetting',
  },
  [EGlobalStateProcessId.RecruitmentGeneralSetting]: {
    GENERAL_SETTING_LIST: '/api/recruitment/setting/GeneralSetting',
  },
  [EGlobalStateProcessId.OneAIFeature]: {
    GET_FEATURE_LIST: '/api/OneAI/features',
  },
  [EGlobalStateProcessId.TaxRegime]: {
    TAX_REGIME_SHOW: '/api/core/Dashboard/Taxregime/show',
  },
  [EGlobalStateProcessId.TimeOfficeExtension]: {
    TIME_OFFICE_EXTENSION: '/api/v2/timeoffice/setting/general/Extensions',
  },
  [EGlobalStateProcessId.MoodbotDetail]: {
    MOODBOT_DETAILS: '/api/core/moodbot/Details',
  },
  [EGlobalStateProcessId.MoodbotReasionList]: {
    MOODMOT_REASON_LIST: '/api/core/moodbot/Reason',
  },
  [EGlobalStateProcessId.PayrollGeneralSetting]: {
    PAYROLL_GENERAL_SETTING: '/api/payroll/Setting/General',
  },
  [EGlobalStateProcessId.WorkflowInboxSetting]: {
    WORKFLOW_INBOX_SETTING_LIST: '/api/core/Workflow/WorkflowInboxSettingList',
  },
  [EGlobalStateProcessId.HelpdeskTicketFeedback]: {
    TICKET_FEEDBACK: '/api/helpdesk/ticket/Feedback',
  }
} as const;
export type TCoreMenuAccessPayload = {
  menuType: 'P' | 'A';
  parentKey: number;
  menuId: number;
  includeMenu: boolean;
}
export type TCoreMenuAccessResponse = {
  menuName: string;
  sequenceNumber: number;
  menuId: number;
  moduleId: number;
  parentKey: number;
  menuType: MenuType;
  iconImagePath: IconImagePath;
  navigationPath: null;
  activeStatus: string;
  tooltipText: string;
  controlKey: null;
  cssClassName: null | string;
  includeMenu: boolean;
  navigationCode: string;
  isPin: boolean;
}

type IconImagePath = "Icon" | "icon" | "Currency";

type MenuType = "P" | "p";
export type TFeedData = {
  feedCards: { versionId: string, cards: IFeedResponse[] },
  countData: { versionId: string, countInfo: TFeedCountResponse | null, },
};
export const hroneIndexDbConfig: DBConfig = {
  name: 'hroneLocalStorageDb',
  version: 1,
  isDefault: true,
  objectStoresMeta: [
    {
      store: 'hronestore',
      storeConfig: { keyPath: 'processId', autoIncrement: false },
      storeSchema: [
        { name: 'processId', keypath: 'processId', options: { unique: true } },
        { name: 'versionId', keypath: 'versionId', options: { unique: false } },
        { name: 'data', keypath: 'data', options: { unique: false } },
        { name: 'employeeId', keypath: 'employeeId', options: { unique: false } },
        { name: 'domainCode', keypath: 'domainCode', options: { unique: false } },
        { name: 'date', keypath: 'date', options: { unique: false } },
      ]
    }
  ]
};

export interface IEnterpriseResponse {
  policyId: number;
  policyName: string;
  vision: string;
  mission: string;
  purpose: string;
  coreValueDetails: Array<{
    coreValueDescription: string;
    fileVirtualPath: string;
    coreValueFileName: string;
    coreValueName: string;
    policyCoreValueId: number;
  }>;
  fileVirtualPath: string;
  uploadedFileName: string;
  uploadedFilePath: string;
}
export type TReferralData = {
  versionId: string;
  data: TReferralDataResponse[];
};
